import axios from '@/static/js/request'
import { ossSQLPost, ossOriginUrl, ossUrl } from '../static/js/oss'
import { getPlatform } from '@/static/js/zjs.js'
const appid = getPlatform().appid

/**
 * 课本点读
 * @param {*年级} grade
 * @param {*学期} volume
 * @param {*版本} version
 */

export function kbDianDuList(grade, volume, version) {
  return ossSQLPost(
    `/basicbook/${appid}/bookListInfo.json`,
    ` SELECT * FROM ossobject [*] o
        WHERE
        o.book.category ='kebendiandu'
        AND o.book.gradesStr LIKE '%${grade},%'
        AND o.book.volume = ${volume}
        AND o.book.version in (${version})`
  )
}
/**
 *
 * @param {*类型 绘本 名著} type
 * @param {*} grade
 * @param {*} volume
 */
export function hbMzDianDuList(type, grade, volume) {
  return ossSQLPost(
    `/basicbook/${appid}/bookListInfo.json`,
    `   SELECT * FROM ossobject [*] o
        WHERE
        o.book.category in ('${type}')
        AND o.book.gradesStr LIKE '%${grade},%'`
  )
}
/**
 *  获取点读的页码页
 * @param {*书的id} bookId
 */

export function dianDuBook(bookId) {
  var url = `/basicbook/${appid}/${bookId}_bookInfo.json`
  return axios.get(ossUrl(url)).then((res) => res.data)
}
/**
 *  获取点读的单页
 * @param {*书的id} bookId
 *  @param {*章节的id} chapterId
 */

export function dianDuPage(bookId, chapterId) {
  var url = `/basicbook/${bookId}/chapter/${chapterId}_allInfo.json`
  return axios.get(ossUrl(url)).then((res) => res.data)
}
